import React from 'react';
import Section from './Section';
import { RiGovernmentLine } from 'react-icons/ri';
import { PiMoneyWavy } from 'react-icons/pi';
import { TbWorld } from 'react-icons/tb';
import { MdSportsSoccer, MdCurrencyExchange } from 'react-icons/md';
import { FaMicrochip } from 'react-icons/fa6';

const language = 'es'

const sections = [
  {
    section: 'Política',
    sectionTitle: {
      es: 'Política',
      it: 'Politica'
    },
    icon: <RiGovernmentLine />,
    route: '/sections/politics'
  },
  {
    section: 'Economía',
    sectionTitle: {
      es: 'Economía',
      it: 'Economia'
    },
    icon: <PiMoneyWavy />,
    route: '/sections/economy'
  },
  {
    section: 'Internacionales',
    sectionTitle: {
      es: 'Internacionales',
      it: 'Esteri'
    },
    icon: <TbWorld />,
    route: '/sections/internationals'
  },
  {
    section: 'Deportes',
    sectionTitle: {
      es: 'Deportes',
      it: 'Sport'
    },
    icon: <MdSportsSoccer />,
    route: '/sections/sports'
  },
  {
    section: 'Tecnología',
    sectionTitle: {
      es: 'Tecnología',
      it: 'Tecnologia'
    },
    icon: <FaMicrochip />,
    route: '/sections/technology'
  },
]

const Sections = () => {
  return (
    <div>
      {
        sections.map((section) => (
          <Section
          sectionTitle={section.sectionTitle[language]}
          section={section.section}
          isOnSection={false}
          icon={section.icon}
          route={section.route}
          />
        ))
      }
    </div>
  )
}

export default Sections